import { useEffect, useMemo, useState } from "react";
import { PageHero } from "@/components/public/Layout";
import { Reveal } from "@/components/public/shared";
import { api } from "@/lib/api";
import { GALLERY as STATIC_GALLERY, IMG } from "@/lib/images";

export default function Gallery() {
  const [items, setItems] = useState(null);
  const [active, setActive] = useState("All");

  useEffect(() => {
    api.get("/gallery")
      .then(({ data }) => setItems(data && data.length ? data.map((g) => ({ url: g.url, cat: g.category, label: g.label, media_type: g.media_type })) : STATIC_GALLERY.map((g) => ({ ...g, media_type: "image" }))))
      .catch(() => setItems(STATIC_GALLERY.map((g) => ({ ...g, media_type: "image" }))));
  }, []);

  const list = items || [];
  const cats = useMemo(() => ["All", ...Array.from(new Set(list.map((g) => g.cat).filter(Boolean)))], [list]);
  const filtered = list.filter((g) => active === "All" || g.cat === active);

  return (
    <div>
      <PageHero label="Gallery" title="Moments we create." subtitle="Food, catering, events and hospitality — a visual record of our craft." image={IMG.buffetGourmet} />
      <section className="bg-ivory py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-10 flex flex-wrap justify-center gap-2">
            {cats.map((c) => (
              <button key={c} data-testid={`gallery-filter-${c.toLowerCase()}`} onClick={() => setActive(c)}
                className={`rounded-full border px-4 py-2 text-[12px] font-medium uppercase tracking-wider transition-colors ${active === c ? "border-espresso bg-espresso text-ivory" : "border-subtle text-espresso/70 hover:border-gold hover:text-gold"}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="columns-2 gap-4 sm:columns-3 lg:columns-4 [&>*]:mb-4" data-testid="gallery-grid">
            {filtered.map((g, i) => (
              <Reveal key={g.label + i} delay={(i % 4) * 40}>
                <div className="group relative overflow-hidden">
                  {g.media_type === "video" ? (
                    <video src={g.url} controls muted loop autoPlay playsInline preload="metadata" className="w-full object-cover" />
                  ) : (
                    <img src={g.url} alt={g.label} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  )}
                  <div className="absolute inset-0 flex items-end bg-gradient-to-t from-charcoal/70 to-transparent opacity-0 transition-opacity group-hover:opacity-100">
                    <span className="p-4 font-display text-lg text-ivory">{g.label}{g.media_type === "video" ? " ▶" : ""}</span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
